import React, {FC} from 'react';
import {DISPLAY, FLEX_DIRECTION, SafeAreaView, View, useDevice} from '@lookiero/aurora';

import {MediaSection} from './MediaSection/MediaSection';
import {TextSection} from './TextSection/TextSection';

export const MaintenanceMode: FC = () => {
  const {screen} = useDevice();
  return (
    <SafeAreaView style={{flex: 1}}>
      <View
        display={DISPLAY.FLEX}
        flexDirection={screen.L ? FLEX_DIRECTION.ROW : FLEX_DIRECTION.COLUMN}
        style={{flex: 1}}
      >
        <TextSection />
        <MediaSection />
      </View>
    </SafeAreaView>
  );
};
